// extracted by mini-css-extract-plugin
export var loadingSpinner = "_5v-1";
export var standaloneTable = "_5v-0";